import * as React from "react";
import { Box } from "@mui/material";
import { HeaderNavProps } from "@/components/header/common/types";
import { ContentType } from "@/components/header/common/header-enums";
import TertiaryPaneHeader from "@/components/header/navigation/desktop/_components/tertiary-navigation/tertiary-pane-header";
import TertiaryNavigationPaneContentWrapped from "@/components/header/navigation/desktop/_components/tertiary-navigation/tertiary-pane-content-wrap";
import TertiaryNavigationPaneContentCards from "@/components/header/navigation/desktop/_components/tertiary-navigation/tertiary-pane-content-cards";
import { injectSourceIntoUrl } from "@/config/unified-search-config";

type TertiaryPaneProps = {
  tertiaryHeaderLabel: string;
  tertiaryHeaderLearnMoreUrl: string;
  tertiaryHeaderViewAllDestinationsUrl: string;
  tertiaryNavItems: HeaderNavProps[];
};
export default function TertiaryNavigationPane(props: TertiaryPaneProps) {
  const { tertiaryHeaderLabel, tertiaryHeaderLearnMoreUrl, tertiaryHeaderViewAllDestinationsUrl, tertiaryNavItems } = props;
  let docType = ContentType.navItem;

  if (tertiaryNavItems[0]?.fields?.content != null) {
    docType = ContentType.document;
  }
  const viewAllURL = injectSourceIntoUrl(tertiaryHeaderViewAllDestinationsUrl, "view_all_tours");
  return (
    <Box>
      <TertiaryPaneHeader
        tertiaryHeaderLabel={tertiaryHeaderLabel}
        tertiaryHeaderLearnMoreUrl={tertiaryHeaderLearnMoreUrl}
        tertiaryHeaderViewAllDestinationsUrl={viewAllURL}
      />
      <Box sx={{ ml: 1 }}>
        {docType === ContentType.document ? (
          <TertiaryNavigationPaneContentCards tertiaryNavItems={tertiaryNavItems} />
        ) : (
          <TertiaryNavigationPaneContentWrapped tertiaryNavItems={tertiaryNavItems} />
        )}
      </Box>
    </Box>
  );
}
